import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: require('@/components/Pages/Login').default },
  { path: '/app', component: require('@/components/Pages/App').default, children: [
    { path: '', redirect: 'app/surveys' },
    { path: 'surveys', component: require('@/components/Pages/App/SurveyDashboard').default },
    { path: 'surveys/:id', component: require('@/components/Pages/App/EditSurveyQuestions').default },
    { path: 'survey-new', component: require('@/components/Pages/App/NewSurvey').default },
  ] },
  { path: '*', redirect: '/app/surveys' },
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes
})

export default router
